import React, { useState, ReactElement, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { styled } from '@erecruit/ui-kit';

interface EditModeContextProps {
  isEditMode: boolean;
  setEditMode: React.Dispatch<React.SetStateAction<boolean>>;
}

export const EditModeContext = React.createContext<EditModeContextProps>({
  isEditMode: false,
  setEditMode: (): void => {},
});

const EditModeWrapperStyle = styled('div')({
  opacity: 0.5,
  position: 'relative',
  height: 'inherit',
});

const ElementOverlay = styled('div')({
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 1001,
});

interface EditModeElementWrapperProps {
  children: ReactElement;
}

const EditModeElementWrapper = ({ children }: EditModeElementWrapperProps) => {
  const { isEditMode } = useContext(EditModeContext);

  return isEditMode ? (
    <EditModeWrapperStyle>
      <ElementOverlay />
      {children}
    </EditModeWrapperStyle>
  ) : (
    children
  );
};

const EditModeContextProvider = ({
  children,
}: {
  children: ReactElement | ReactElement[];
}) => {
  const [isEditMode, setEditMode] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== '/dashboard') {
      setEditMode(false);
    }
  }, [location.pathname, setEditMode]);

  const editMode = {
    isEditMode,
    setEditMode,
  };

  return (
    <EditModeContext.Provider value={editMode}>
      {children}
    </EditModeContext.Provider>
  );
};

export default EditModeContextProvider;
export { ElementOverlay, EditModeElementWrapper };
